import { render, staticRenderFns } from "./ErrorCustom.vue?vue&type=template&id=5718d7aa&"
import script from "./ErrorCustom.vue?vue&type=script&lang=js&"
export * from "./ErrorCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports